import { getDisplayMode } from "./libs";
import Modal from "./Modal";
import gsap from "gsap";

const setVideoModal = (swiper) => {
  class VideoModal extends Modal {
    constructor(params) {
      super(params);
    }

    afterCloseModal() {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.closing = false;
    }

    beforeCloseModal() {
      if (swiper) swiper.autoplay.start();
      this.closeModal()
    }

    afterOpenModal() {
      if (swiper) swiper.autoplay.stop();
      this.opening = false;
    }

    beforeOpenModal() {
      this.video = this.currentModal.querySelector('.video__player');

      this.video.src = this.video.dataset.src;
      this.video.load();

      this.video.addEventListener('canplaythrough', () => {
        gsap.to(this.video, {
          autoAlpha: 1,
          duration: 0.8,
          ease: 'sine.inOut'
        })
        this.video.play();
      }, { once: true });

      this.openModal();
    }
  }

  if (getDisplayMode() == 2) {
    const viodeoModal = new VideoModal({
      triggerClass: '.js-video-modal-trigger'
    })
  }
};

export default setVideoModal;